<template>
    <v-expansion-panels
        class="product-spec-list panels-custom-outlined w-100"
        @update:modelValue="onChange"
        static
    >
        <v-expansion-panel
            elevation="0"
            :eager="hasOpened"
        >
            <v-expansion-panel-title
                class="
                    text-uppercase
                    font-weight-bold
                    cursor-pointer
                    no-user-select
                    px-4
                    py-3
                "
            >
                Product Specs
            </v-expansion-panel-title>
            <v-expansion-panel-text
                class="ma-0"
            >
                <ProductSpecListItems
                    :skus="skus"
                    :current-sku-uid="currentSkuUid"
                    :attrs-maps="attrsMaps"
                    :spec-groups="specGroups"
                    :use-all-skus="useAllSkus"
                ></ProductSpecListItems>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script lang="ts" setup>
    import ProductSpecListItems from '~/components/products/ProductSpecListItems/ProductSpecListItems.vue';
    import type {
        Sku,
        ProductAttrsMaps,
        ProductAttrsGroupSpec
    } from '~/types';

    withDefaults(
        defineProps<{
            attrsMaps: ProductAttrsMaps;
            specGroups: ProductAttrsGroupSpec[];
            currentSkuUid?: Nilish<string>;
            skus?: Sku[];
            useAllSkus?: boolean;
        }>(),
        {
            useAllSkus: false
        }
    );

    const hasOpened = ref<boolean>(false);

    function onChange(): void {
        hasOpened.value = true;
    }
</script>

<style lang="scss">
.product-spec-list {
    dl {
        display: grid;
        grid-template-columns: auto 1fr;

        dt {
            font-weight: 500;
        }

        dt,
        dd {
            padding: 0.4rem 16px;
            font-size: 90%;
        }

        dt:nth-child(4n+1),
        dd:nth-child(4n+2) {
            background-color: rgb(var(--v-theme-accent-lighten-2));
        }

        ul {
            list-style: none;
            margin: 0;
            padding: 0;
        }
    }
}
</style>
